/**
 * Iframe component
 */

import '../../js/vendor/polyfills/polyfill-request-animation-frame.js';
import '../../js/vendor/polyfills/polyfill-scroll-to.js';

if (document.querySelectorAll('.c-iframe').length > 0) {
	window.addEventListener('message', (e) => {
		let iframe = document.querySelector('.c-iframe iframe');
		if (iframe.contentWindow === e.source) {
			if (e.data.unload === true) {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}

			iframe.parentNode.height = e.data.height + 'px';
			iframe.parentNode.style.height = e.data.height + 'px';
		}
	});
}



// WEBPACK FOOTER //
// ./components/iframe/c-iframe.js